import moment from 'moment';
import {
    validateCheckboxGroup,
    validateInputString,
    validateRadio,
    validateSelect,
} from './validation/validation';
import { dateFormatZurich, formatDate } from '../../utils/datetime';
import { KYCData, KYCDataPayload, KYCErrorData } from './kyc.types';

const toUndefinedIfZero = (val: number | undefined) => (val === 0 ? undefined : val);

export const errorModel: (
    data: KYCDataPayload,
    isSwissNationality: boolean,
) => Promise<KYCErrorData> = async (
    data: KYCDataPayload,
) => ({
    professionalSituation: validateSelect(data?.professionalSituation),
    employer: validateInputString(data?.employer),
    industry: validateSelect(data?.industry),
    degreeOfEducation: validateSelect(data?.degreeOfEducation),
    pepStatus: validateRadio(data?.pepStatus),
    pepDescription: data?.pepStatus
        ? validateSelect(data?.pepDescription)
        : null,
    beneficialOwner: validateRadio(data?.beneficialOwner),
    originOfAssets: validateCheckboxGroup(data?.originOfAssets),
});
export const getModel = (data: KYCData) => ({
    employer: data?.extEmployer,
    originOfAssets: data?.extOriginOfAssets,
    pepStatus: data?.extPepQuestion,
    beneficialOwner: data?.extBeneficialOwner,
    additionalInformation: data?.extOriginOfAssetsOther,
    pepDescription: toUndefinedIfZero(data?.extPepDescription),
    inSwitzerlandSince: toUndefinedIfZero(data?.extInSwitzerlandSince),
    plannedLengthOfStay: toUndefinedIfZero(data?.extPlannedLengthOfStay),
    degreeOfEducation: toUndefinedIfZero(data?.extDegreeOfEducation),
    professionalSituation: toUndefinedIfZero(data?.extProfessionalSituation),
    industry: toUndefinedIfZero(data?.extIndustry),
    modifiedBy: data?.extKycModifiedByMemberId,
    modifiedDate: data?.extKycModifiedDate
        ? formatDate(data?.extKycModifiedDate, dateFormatZurich)
        : '-',
});

export const sendModel = ({ data } : { data: KYCDataPayload }) => ({
    details: {
        extKyc: {
            extOriginOfAssets: data?.originOfAssets?.length
                ? data?.originOfAssets.map((i) => parseInt(i, 10))
                : [],
            extProfessionalSituation: data?.professionalSituation || 0,
            extIndustry: data?.industry || 0,
            extEmployer: data?.employer || '',
            extDegreeOfEducation: data?.degreeOfEducation || 0,
            extPepQuestion: data?.pepStatus || false,
            extPepDescription: data?.pepStatus ? (data?.pepDescription || 0) : null,
            extInSwitzerlandSince: data?.inSwitzerlandSince || null,
            extPlannedLengthOfStay: data?.plannedLengthOfStay || null,
            extOriginOfAssetsOther: data?.additionalInformation || '',
            extBeneficialOwner: data?.beneficialOwner || 0,
            extKycModifiedDate: moment().format('YYYY-MM-DD HH:mm:ss.SSS'),
            extKycModifiedByMemberId: data?.modifiedBy,
        },
    },
});
